import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { SectionHeader } from '@/components/SectionHeader';
import { Typography } from '@/components/Typography';
import { px2rem } from '@/theme';

import { ReactComponent as RulerSVG } from '@/assets/ruler.svg';

export const SmallHeader = styled(SectionHeader)`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing(4)};
  font-size: ${({ theme }) => theme.fontSizes.h5};
`;

export const AvailableSizesRow = styled(Flex)`
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Size = styled(Typography)<{ isSelected: boolean }>`
  text-transform: uppercase;
  cursor: pointer;

  ${({ isSelected, theme }) => css`
    color: ${theme.colors.secondaryGrey};
    font-weight: ${theme.fontWeights.bold};
    padding: ${theme.spacing(1, 2)};

    ${isSelected &&
    css`
      background-color: ${theme.colors.primaryBlue};
      color: ${theme.colors.white};
    `}
  `}
`;

export const Ruler = styled(RulerSVG)`
  width: 22px;
  height: 22px;
  cursor: pointer;
  margin: ${({ theme }) => theme.spacing(1, 2)};
`;

export const SizeInfoText = styled(Typography)`
  text-align: center;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.secondaryGrey};
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const Divider = styled(Box)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(3)};
    border-bottom: 1px solid ${theme.colors.defaultAdd5};
  `}
`;

// @TODO : Duplication with src/views/StrapView/components/AddToBagDrawer/components/BucklesSection/BucklesSection.styles.tsx -> BucklesWrapper
export const BucklesWrapper = styled(Box)<{ $nbBuckles: number }>`
  ${({ $nbBuckles, theme }) => css`
    display: ${$nbBuckles > 1 ? 'grid' : 'block'};
    justify-content: center;
    grid-template-columns: auto auto auto auto;
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    gap: ${theme.spacing(0.5)};
  `}
`;

export const NiceToHaveHeader = styled(SmallHeader)`
  padding: 0;
  margin-top: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const NiceToHaveText = styled(Typography)`
  text-align: center;
  line-height: ${px2rem(16)};

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p4};
    margin-bottom: ${theme.spacing(2)};
  `}
`;
